/**
 * Landing hero visual (static image). No Mapbox on the marketing hero.
 * Default: `public/images/landing-hero-network.png`. Override with `REACT_APP_LANDING_HERO_IMAGE` (full URL).
 */
export const LANDING_HERO_VISUAL_ALT =
  'United States at night as a glowing freight and data network: city lights, warm and cool hubs, and arcing connection lines on a dark map.' as const;

export function getLandingHeroImageSrc(): string {
  const custom = process.env.REACT_APP_LANDING_HERO_IMAGE?.trim();
  if (custom) return custom;
  const base = process.env.PUBLIC_URL || '';
  const path = '/images/landing-hero-network.png';
  return base ? `${base.replace(/\/$/, '')}${path}` : path;
}
